import { useContractKlineComponent } from '@/hooks/use-contract-kline-component'
import type { ResolutionString } from 'charting-library'
import classNames from 'classnames'
import { ElSpace } from 'element-plus'
import { useI18n } from 'i18n-utils'
import { useDoubleContractKlineStore } from 'store'
import { LoadingView } from 'ui-components'
import '../styles/trading-view-layout.scss'
import Depth from './Depth.tsx'

interface TradingViewProps {}

export const ContractKline = defineComponent<TradingViewProps>({
  setup() {
    const { t } = useI18n()
    const contractKline = useContractKlineComponent()
    const klineStore = useDoubleContractKlineStore()

    onBeforeUnmount(() => {
      klineStore.unsubscribeAll(klineStore.currentSymbolId!)
      klineStore.$dispose()
    })

    return () => (
      <div class="trading-view-layout" id="trading-view-chart">
        <div class="flex justify-between items-center">
          <div class="resolution-list">
            {contractKline.resolutionList.map((item) => (
              <div
                class={classNames('resolution-item', {
                  active: klineStore.currentResolution === item.value,
                })}
                key={item.value}
                onClick={() => contractKline.setResolution(item.value as ResolutionString)}
              >
                {t(item.label)}
              </div>
            ))}
          </div>
          <ElSpace size={24} class="tab !pr-[8px]">
            <span class={classNames('cursor-pointer', { active: contractKline.activeKey.value === 'LINE' })} onClick={() => contractKline.onStepChange('LINE')}>
              {t('K线图')}
            </span>
            <span class={classNames('cursor-pointer', { active: contractKline.activeKey.value === 'MAP' })} onClick={() => contractKline.onStepChange('MAP')}>
              {t('深度图')}
            </span>
          </ElSpace>
        </div>
        <div
          ref={contractKline.tradingViewMounted}
          class={classNames('trading-view-mounted', {
            'is-ready': !contractKline.loadingChart.value,
          })}
          style={{ display: contractKline.activeKey.value === 'LINE' ? 'block' : 'none' }}
        ></div>
        {contractKline.activeKey.value !== 'LINE' && <Depth></Depth>}
        {(contractKline.loadingChart.value || klineStore.loadingHistoryKline) && (
          <div class="loading-chart">
            <LoadingView color="var(--colors-primary)" />
          </div>
        )}
      </div>
    )
  },
})
